import { deleteApi, get, post } from "../GenericServices";

const Vertical = {
  getVerticalList: (queryString) => {
    return get(`vertical?${queryString}`);
  },
  verticalData: (id) => {
    return get(`vertical/${id}`);
  },
  saveVertical: (data) => {
    return post("vertical", data);
  },
  deleteVertical: (id) => {
    return deleteApi(`vertical/${id}`);
  },
};

export default Vertical;
